<template>
  <v-card class="organization-purchase">
    <h1>Collections fulfillment</h1>
    <v-divider></v-divider>
    <v-stepper v-model="purchaseStep">
      <v-stepper-header>
        <v-stepper-step editable step="1">
          Collection Dashboard
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step step="2"> Collections Assignment </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step step="3">
          Review Collection Fulfillment
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step step="4">
          Confirm Collection Fulfillment
        </v-stepper-step>
        <v-divider></v-divider>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <div class="row mb-5">
            <div class="col">
              <div class="">
                <v-text-field
                  id="searchkeyword"
                  v-model="paging_purchased.keyword"
                  label="Search"
                  required
                  append-outer-icon="mdi-table-search"
                  @click:append-outer="onSearch"
                  v-on:keyup.enter="onSearch()"
                >
                </v-text-field>
              </div>
            </div>
            <div class="col d-flex align-center justify-end">
              <div class="float-right">
                <v-btn
                  color="primary"
                  class=""
                  @click="purchaseStep = 2"
                  id="btnpurchaseStep"
                  >New</v-btn
                >
              </div>
            </div>
          </div>

          <v-data-table
            :headers="purpub_headers"
            :items="fulfillmentList"
            hide-default-footer
          >
            <template v-slot:item.coreCollectionId="props">
              <span>{{ props.item }}</span>
            </template>
            <template v-slot:item.DateOfPayment="props">
              <span>{{ props.item.DateOfPayment | DateFromatDDMMYYY }}</span>
            </template>
            <template v-slot:item.id="props">
              <router-link
                :to="{
                  name: 'FulfillmentDetails',
                  params: {
                    id: props.item.id,
                    collection: props.item.IsCollection,
                    page: paging_purchased.page,
                    name: props.item.OrganizationName,
                    refno: props.item.ReferenceNo,
                  },
                }"
              >
                <v-icon small color="blue darken-2"> mdi-domain </v-icon>
              </router-link>
            </template>
            <template v-slot:item.IsCancel="props">
              <span v-if="!props.item.IsCancel">
                <v-icon
                  small
                  class="mr-2 icon-cancel"
                  @click="onCancel(props.item)"
                  >mdi-cancel</v-icon
                >
              </span>
              <span v-if="props.item.IsCancel">Canceled</span>
            </template>
          </v-data-table>
          <v-row>
            <v-col cols="12">
              <Pagination
                :paging="paging_purchased"
                v-on:next="onNextPagePurchased"
              />
            </v-col>
          </v-row>

          <div class="row">
            <div class="pr-8 ml-auto mb-10">
              <a @click="download"
                ><v-icon large color="blue" class="px-1">
                  mdi-cloud-download </v-icon
                >Download</a
              >
            </div>
          </div>
        </v-stepper-content>
      </v-stepper-items>

      <v-stepper-content step="2">
        <v-card class="collection-purchase">
          <h1>Collections Fulfillment</h1>
          <v-divider></v-divider>
          <div class="row mb-5">
            <div class="col d-flex align-center">
              <span class="mr-4 mt-4">Organization</span>
              <v-select
                id="organizationSelect"
                class="organization-dropdown"
                :items="organizationList"
                label="Name"
                item-text="Name"
                item-value="id"
                v-model="purchaseOrder.OrganizationId"
              ></v-select>
            </div>
          </div>
          <div class="row">
            <v-col cols="12"
              ><v-data-table
                v-model="selected_fulfillment"
                :headers="fulfillment_headers"
                :items="collectionList"
                class="elevation-1"
                show-select
                id="fulfillment"
              >
                <template v-slot:item.name="props">
                  <p class="text-wrap">{{ props.item.name }}</p>
                </template>
                <template v-slot:item.concurrentUsers="props">
                  <v-text-field
                    v-model="props.item.concurrentUsers"
                    hide-details
                    single-line
                    type="number"
                    id="concurrentUsers"
                  />
                </template>
                <template v-slot:item.satrtDate="props">
                  <v-menu
                    v-model="props.item.satrtDateAction"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        id="startDate"
                        v-model="props.item.satrtDate"
                        prepend-icon="mdi-calendar"
                        label="Start date"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      id="startDatePic"
                      v-model="props.item.satrtDate"
                      @input="props.item.satrtDateAction = false"
                      :max="props.item.endDate"
                    ></v-date-picker>
                  </v-menu>
                </template>
                <template v-slot:item.endDate="props">
                  <v-menu
                    v-model="props.item.endDateAction"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        id="enddate"
                        v-model="props.item.endDate"
                        prepend-icon="mdi-calendar"
                        label="End date"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      id="endDatePic"
                      v-model="props.item.endDate"
                      @input="props.item.endDateAction = false"
                      :min="props.item.satrtDate"
                    ></v-date-picker>
                  </v-menu>
                </template> </v-data-table
            ></v-col>
          </div>
          <v-row align="center">
            <v-col cols="12">
              <Notification :notify="notify1" />
            </v-col>
          </v-row>
          <div class="row">
            <div class="col d-flex justify-end">
              <div class="ms- 6 col d-flex justify-start">
                <v-btn class="" @click="purchaseStep = 1" id="btnback"
                  >Back</v-btn
                >
              </div>
              <v-btn
                color="primary"
                class=""
                id="next1"
                @click="navReviewPurchase"
                >Next</v-btn
              >
            </div>
          </div>
        </v-card>
      </v-stepper-content>

      <v-stepper-content step="3">
        <v-card class="review-purchase-collection">
          <h1>Review collection fulfillment</h1>
          <v-divider></v-divider>
          <div class="row mt-5 mb-5">
            <div class="col-8">
              <div class="row">
                <div class="col-4">
                  <p>Organization</p>
                  <p>Collection</p>
                </div>
                <div class="col-8">
                  <p>{{ comOrganizationName }}</p>
                  <p>{{ collectionNames }}</p>
                </div>
              </div>
            </div>
          </div>
          <v-data-table
            :headers="fulfillment_headers"
            :items="selected_fulfillment"
          >
            <template v-slot:item.satrtDate="props">
              {{ props.item.satrtDate | DateFromatDDMMYYY }}
            </template>
            <template v-slot:item.endDate="props">
              {{ props.item.endDate | DateFromatDDMMYYY }}
            </template>
          </v-data-table>
          <div class="row">
            <v-btn class="ms-6" @click="purchaseStep = 2">Back</v-btn>
            <div class="col d-flex justify-end">
              <v-btn color="primary" class="" @click="purchaseStep = 4"
                >Next</v-btn
              >
            </div>
          </div>
        </v-card>
      </v-stepper-content>

      <v-stepper-content step="4">
        <v-card class="confirm-purchase-collection">
          <h1>Confirm collection fulfillment</h1>
          <v-divider></v-divider>
          <div class="row mt-5 mb-5">
            <div class="col-8">
              <div class="row">
                <div class="col-4">
                  <p>Organization</p>
                  <p>Collection</p>
                </div>
                <div class="col-8">
                  <p>{{ comOrganizationName }}</p>
                  <p>{{ collectionNames }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <v-menu
                v-model="DateOfPaymentMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    id="DateOfPayment"
                    v-model="purchaseOrder.DateOfPayment"
                    label="Date of Payment"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  id="dateOfPaymentdrp"
                  v-model="purchaseOrder.DateOfPayment"
                  @input="DateOfPaymentMenu = false"
                ></v-date-picker>
              </v-menu>

              <v-text-field
                id="Amount"
                v-model="purchaseOrder.Amount"
                label="Amount"
              ></v-text-field>
              <v-textarea label="Description"></v-textarea>
              <v-text-field-simplemask
                id="ReferenceNo"
                v-model="purchaseOrder.ReferenceNo"
                v-bind:label="'Reference No'"
                v-bind:properties="{
                  prefix: '',
                  suffix: '',
                  readonly: false,
                  disabled: false,
                  outlined: false,
                  clearable: true,
                  placeholder: 'AA-1234',
                }"
                v-bind:options="{
                  inputMask: '##-#####',
                  outputMask: '##-#####',
                  empty: null,
                  applyAfter: false,
                  alphanumeric: true,
                  lowerCase: false,
                }"
                v-bind:focus="focus"
                v-on:focus="focus = false"
              />
              <v-text-field
                id="PaymentMadeBy"
                v-model="purchaseOrder.PaymentMadeBy"
                label="Payment Made By"
              ></v-text-field>
            </div>
          </div>
          <v-row align="center">
            <v-col cols="12">
              <Notification :notify="notify2" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn class="ms-6" @click="purchaseStep = 3" id="btnPurchaseStep"
                >Back</v-btn
              >
              <div class="col d-flex justify-end">
                <v-btn
                  color="primary"
                  class=""
                  @click="createFulfillment"
                  id="createFullFillmentBtn"
                  >Confirm fulfillment</v-btn
                >
              </div>
            </v-col>
          </v-row>
          <ConfirmationDialog ref="confirm" />
        </v-card>
      </v-stepper-content>
    </v-stepper>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import Notification from "@/components/Notification";
import Pagination from "@/components/Pagination";
import ConfirmationDialog from "@/components/ConfirmationDialogYesNo";
import moment from "moment";
import lodash from "lodash";
import * as api from "@/api";
export default {
  name: "FulfillmentCollections",
  components: {
    Notification,
    Pagination,
    ConfirmationDialog,
  },
  data() {
    return {
      purchaseStep: 1,
      purchaseOrder: {
        id: 0,
        Amount: 0,
        DateOfPayment: "",
        ReferenceNo: "",
        PaymentMadeBy: "",
        PaymentConfirmed: true,
        IsCoreCollection: true,
        OrganizationId: 0,
        PurchaseDetails: [],
      },
      organizationList: [],
      purpub_headers: [
        {
          text: "Organization Name",
          align: "start",
          sortable: false,
          value: "OrganizationName",
        },
        {
          text: "Date of Payment",
          align: "start",
          sortable: false,
          value: "DateOfPayment",
        },
        {
          text: "Amount",
          align: "start",
          sortable: false,
          value: "Amount",
        },
        {
          text: "Payment Made By",
          align: "start",
          sortable: false,
          value: "PaymentMadeBy",
        },
        {
          text: "Payment Confirmation",
          align: "start",
          sortable: false,
          value: "PaymentConfirmed",
        },
        {
          text: "Zoho Reference No",
          align: "start",
          sortable: false,
          value: "ReferenceNo",
        },
        {
          text: "Details",
          align: "start",
          sortable: false,
          value: "id",
        },
        {
          text: "",
          align: "start",
          sortable: false,
          value: "IsCancel",
        },
      ],
      fulfillment_headers: [
        {
          text: "Collection",
          align: "start",
          sortable: false,
          value: "Name",
          width: "30%",
        },
        {
          text: "Concurrent Users",
          align: "start",
          sortable: false,
          value: "concurrentUsers",
          width: "7%",
        },
        {
          text: "Start Date",
          align: "start",
          sortable: false,
          value: "satrtDate",
          width: "30%",
        },
        {
          text: "End Date",
          align: "start",
          sortable: false,
          value: "endDate",
          width: "35%",
        },
      ],
      collectionList: [],
      fulfillmentList: [],
      selected_fulfillment: [],
      coreCollection_mockup: [
        { name: "Collection 1", id: 1 },
        { name: "Collection 2", id: 2 },
      ],
      paging_purchased: { count: 10, page: 1, size: 10, keyword: "" },
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      notify1: {
        type: 0,
        message: "",
        errors: [],
      },
      notify2: {
        type: 0,
        message: "",
        errors: [],
      },
      DateOfPaymentMenu: false,
      noOfCopiesRules: [(v) => v || "No of copies is required"],
      overlay: false,
    };
  },
  methods: {
    getOrganizationList() {
      console.log(this.paging_purchased);
      this.organizationList = [];
      return new Promise((resolve, reject) => {
        api
          .getAll("organization", this.paging_purchased)
          .then((response) => {
            this.organizationList = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onSearch() {
      this.paging_purchased.page = 1;
      this.getOrganizationPurchaseByPagin();
    },
    getOrganizationPurchaseByPagin() {
      let that = this;
      that.overlay = true;
      that.fulfillmentList = [];
      console.log(this.paging_purchased);

      new Promise((resolve, reject) => {
        api
          .getByPagin("purchase-order/collection", this.paging_purchased)
          .then((response) => {
            let collection = lodash.filter(response.data.data, {
              IsCollection: true,
            });
            lodash.orderBy(collection, ["id"]);
            collection.forEach((element, index) => {
              that.fulfillmentList.push(element);
            });
            this.paging_purchased.count = response.data.count;
            that.overlay = false;
          })
          .catch((error) => {
            reject(error);
            that.overlay = false;
          });
      });
    },
    validatePurcchaseOrg() {
      if (this.purchaseOrder.OrganizationId > 0) {
        return true;
      } else {
        this.notify1.type = 4;
        this.notify1.errors = [];
        this.notify1.errors.push("Organization is rquired");
        setTimeout(() => {
          this.notify1.type = 0;
        }, 3000);
        return false;
      }
    },
    validateDateOfPayment() {
      if (this.purchaseOrder.DateOfPayment != "") {
        return true;
      } else {
        this.notify2.type = 4;
        this.notify2.errors = [];
        this.notify2.errors.push("Date of Payment is rquired");
        setTimeout(() => {
          this.notify2.type = 0;
        }, 3000);
        return false;
      }
    },
    validatePaymentAmount() {
      var valid_amount_regex = /^[0-9]+(\.[0-9]{1,2})?$/gm;
      if (
        this.purchaseOrder.Amount != null &&
        !valid_amount_regex.test(this.purchaseOrder.Amount)
      ) {
        this.notify2.type = 4;
        this.notify2.errors = [];
        this.notify2.errors.push(
          "Invalid Payment amount, Field can only contain positive numbers"
        );
        setTimeout(() => {
          this.notify2.type = 0;
        }, 3000);
        return false;
      } else if (this.purchaseOrder.Amount > 0) {
        return true;
      } else {
        this.notify2.type = 4;
        this.notify2.errors = [];
        this.notify2.errors.push("Payment amount should be grator than zero");
        setTimeout(() => {
          this.notify2.type = 0;
        }, 3000);
        return false;
      }
    },
    validateConcurrentUsers() {
      let invalidCopy = lodash.filter(this.selected_fulfillment, function (o) {
        return o.concurrentUsers == null || o.concurrentUsers == 0;
      });
      if (invalidCopy != null && invalidCopy.length > 0) {
        this.notify1.type = 4;
        this.notify1.errors = [];
        this.notify1.errors.push("Invalid concurrent users specified");
        setTimeout(() => {
          this.notify1.type = 0;
        }, 3000);
        return false;
      } else {
        return true;
      }
    },
    validateStartDate() {
      let invalidCopy = lodash.filter(this.selected_fulfillment, function (o) {
        return (
          o.satrtDate == null ||
          o.satrtDate == "" ||
          !moment(o.satrtDate).isValid()
        );
      });
      if (invalidCopy != null && invalidCopy.length > 0) {
        this.notify1.type = 4;
        this.notify1.errors = [];
        this.notify1.errors.push("Invalid start date specified");
        setTimeout(() => {
          this.notify1.type = 0;
        }, 3000);
        return false;
      } else {
        return true;
      }
    },
    validateEndDate() {
      let invalidCopy = lodash.filter(this.selected_fulfillment, function (o) {
        return (
          o.endDate == null || o.endDate == "" || !moment(o.endDate).isValid()
        );
      });
      if (invalidCopy != null && invalidCopy.length > 0) {
        this.notify1.type = 4;
        this.notify1.errors = [];
        this.notify1.errors.push("Invalid end date specified");
        setTimeout(() => {
          this.notify1.type = 0;
        }, 3000);
        return false;
      } else {
        return true;
      }
    },
    validateFulFillmentSelection() {
      if (
        this.selected_fulfillment != null &&
        this.selected_fulfillment.length > 0
      ) {
        return true;
      } else {
        this.notify1.type = 4;
        this.notify1.errors = [];
        this.notify1.errors.push("No item has been selected");
        setTimeout(() => {
          this.notify1.type = 0;
        }, 3000);
        return false;
      }
    },
    validatePaidAmount() {
      if (this.purchaseOrder.Amount == null || this.purchaseOrder.Amount == 0) {
        this.notify1.type = 4;
        this.notify1.errors = [];
        this.notify1.errors.push("Invalid Amount specified");
        setTimeout(() => {
          this.notify1.type = 0;
        }, 3000);
        return false;
      } else {
        return true;
      }
    },
    validateReferenceNo() {
      if (
        this.purchaseOrder.ReferenceNo == null ||
        this.purchaseOrder.ReferenceNo == ""
      ) {
        this.notify1.type = 4;
        this.notify1.errors = [];
        this.notify1.errors.push("Invalid ReferenceNo");
        setTimeout(() => {
          this.notify1.type = 0;
        }, 3000);
        return false;
      } else {
        return true;
      }
    },
    navReviewPurchase() {
      if (
        this.validatePurcchaseOrg() == true &&
        this.validateFulFillmentSelection() == true &&
        this.validateConcurrentUsers() == true &&
        this.validateStartDate() == true &&
        this.validateEndDate() == true
      ) {
        this.purchaseStep = 3;
      }
    },
    getCollections() {
      let that = this;
      new Promise((resolve, reject) => {
        api
          .getAll("collection")
          .then((response) => {
            console.log(response);
            response.data.forEach((e) => {
              e.satrtDate = "";
              e.endDate = "";
              that.collectionList.push(e);
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async createFulfillment() {
      let that = this;
      that.overlay = true;
      if (this.validateDateOfPayment() == false) {
        return;
      }
      if (this.validatePaymentAmount() == false) {
        return;
      }
      if (this.validateReferenceNo() == false) {
        return;
      }
      let purchaseReqeust = {
        id: 0,
        Amount: parseInt(that.purchaseOrder.Amount),
        DateOfPayment: moment(that.purchaseOrder.DateOfPayment).toDate(),
        ReferenceNo: that.purchaseOrder.ReferenceNo,
        PaymentMadeBy: that.purchaseOrder.PaymentMadeBy,
        PaymentConfirmed: that.purchaseOrder.PaymentConfirmed,
        IsCollection: that.purchaseOrder.IsCoreCollection,
        OrganizationId: that.purchaseOrder.OrganizationId,
        PurchaseDetails: [],
      };
      if (
        (that.selected_fulfillment != null) &
        (that.selected_fulfillment.length > 0)
      ) {
        purchaseReqeust.PurchaseDetails = that.selected_fulfillment.map((e) => {
          return {
            NoOfCopies: Number(e.concurrentUsers),
            StartDate: moment(e.satrtDate).toDate(),
            EndDate: moment(e.endDate).toDate(),
            PublicationId: e.PublicationId,
            collectionId: e.id,
            journalId: e.journalId,
            id: 0,
            collectionType: e.collectionType,
          };
        });
      }
      new Promise((resolve, reject) => {
        api
          .update("purchase-order", purchaseReqeust)
          .then((response) => {
            resolve(response);
            if (response.status === 200 || response.status === 201) {
              this.purchaseCompleted = true;
              this.notify.type = 1;
              this.notify.message =
                purchaseReqeust.id === 0
                  ? "successfully saved."
                  : "successfully updated.";
              this.purchaseStep = 1;
              this.getOrganizationPurchaseByPagin();
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
            } else {
              this.purchaseCompleted = false;
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
            }
          })
          .catch((error) => {
            this.notify.type = 4;
            this.notify.errors.push("Failed to save data. " + error);
            reject(error);
          });
      });
    },
    getDatePickerRef(prefix, id) {
      return prefix + id;
    },
    onNextPagePurchased(page) {
      this.paging_purchased.page = page;
      this.getOrganizationPurchaseByPagin();
    },
    async onCancel(item) {
      console.log(item);
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to cancel this record?"
        )
      ) {
        window.location = `/purchaseOrderCancel/${item.id}/${item.OrganizationId}/${item.IsCollection}`;
      }
    },
    download() {
      api.downloadFile("purchase-order/download/fulfillment", "fulfillment.csv")
    }
  },
  mounted() {
    this.paging_purchased.count = 10;
    this.paging_purchased.page = 1;
    this.paging_purchased.size = 10;
    if (this.$route.params.page != null) {
      this.paging_purchased.page = parseInt(this.$route.params.page);
    }
    this.onSearch();
    this.getOrganizationList();
    this.getCollections();
  },
  filters: {
    DateFromatDDMMYYY: function (value) {
      if (value == null || value == "") {
        return "MM-DD-YYYY";
      }
      return moment(value).format("MM-DD-YYYY");
    },
  },
  computed: {
    comOrganizationName: function () {
      let selectedOrg = lodash.filter(this.organizationList, {
        id: this.purchaseOrder.OrganizationId,
      });
      if (selectedOrg != null && selectedOrg.length > 0) {
        return selectedOrg[0].Name;
      } else {
        return "not found";
      }
    },
    comMinStartDate: function () {
      if (
        this.selected_fulfillment != null &&
        this.selected_fulfillment.length > 0
      ) {
        let moments = this.selected_fulfillment.map((d) => {
          let momentDate = moment(d.StartDate);
          if (momentDate.isValid()) {
            return momentDate;
          } else {
            return null;
          }
        });
        var min = moment.min(moments);
        return min != null && min.isValid() ? min.format("MM/DD/YYYY") : "";
      } else {
        return "";
      }
    },
    comMaxEndDate: function () {
      if (
        this.selected_fulfillment != null &&
        this.selected_fulfillment.length > 0
      ) {
        let moments = this.selected_fulfillment.map((d) => {
          let momentDate = moment(d.EndDate);
          if (momentDate.isValid()) {
            return momentDate;
          } else {
            return null;
          }
        });
        var min = moment.max(moments);
        return min != null && min.isValid() ? min.format("MM/DD/YYYY") : "";
      } else {
        return "";
      }
    },
    collectionNames: function () {
      if (
        this.selected_fulfillment != null &&
        this.selected_fulfillment.length > 0
      ) {
        let NameList = this.selected_fulfillment.map((d) => {
          return d.Name;
        });
        let names = NameList.join(", ");
        return names;
      } else {
        return "";
      }
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/FulfillmentCollections.vue